$(function () {

	let inputMask = function() {

		let iti;

		var input = document.querySelectorAll('input[type="tel"]');
		var iti_el = $('.iti.iti--allow-dropdown.iti--separate-dial-code');
		if(iti_el.length){
			iti.destroy();
		}
		for(var i = 0; i < input.length; i++){
			iti = intlTelInput(input[i], {
				autoHideDialCode: false,
				autoPlaceholder: "aggressive" ,
				initialCountry: "auto",
				separateDialCode: true,
				customPlaceholder:function(selectedCountryPlaceholder,selectedCountryData){
					return ''+selectedCountryPlaceholder.replace(/[0-9]/g,'_').replace(/\s/g, '-');
				},
				geoIpLookup: function(callback) {
					$.ajax({
						url: "https://get.geojs.io/v1/ip/geo.js",
						dataType: "jsonp",
						jsonpCallback:"geoip",
						success: function(data) {
							callback (data.country_code);
						},
						error: function () {
							callback('ru')
						}
					});
				},
				utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.0/js/utils.js" // just for
			});

			$('input[type="tel"]').on("focus click countrychange", function(e, countryData) {
				let pl = $(this).attr('placeholder') + '';
				pl = pl.replaceAll('_', '9')
				if(pl !== 'undefined'){
					new Inputmask(
						{
							mask: pl,
							placeholder: "_",
							clearMaskOnLostFocus: true
						}
					).mask(this);
				}
				if (!$(this).val()) {
					this.setSelectionRange(0, 0)
				}
			});
		}
	}

	inputMask();

	window.inputMask = inputMask;
	
});
